require('./transferView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { Component } = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @helpers
const { isSepa } = require('utilities/transfersHelper');

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKModal = require('components/commons/OKModal/OKModal');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// @ components
const {
    TransferStep1
} = require('components/transfersSteps/transferSteps/transferStep1/transferStep1');
const {
    TransferStep2
} = require('components/transfersSteps/transferSteps/transferStep2/transferStep2');
const TransferSuccessStep = require('components/transfersSteps/transferSteps/transferSuccessStep/transferSuccessStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton');
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { TransferViewWarningModal } = require('routes/transferView/transferViewWarningModal');
const { TransferViewErrors } = require('routes/transferView/transferViewErrors');

// @actions
const transferActions = require('actions/transferActions');
const scheduledTransfersActions = require('actions/scheduledTransfers');
const intervenersActions = require('actions/getAccountInterveners');
const bankEntityActions = require('actions/bankEntity');
const printerActions = require('actions/contactCenter/printer');
const emitedTransfersDetailsActions = require('actions/emitedTransfersDetails');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const contractsActions = require('actions/contracts');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @constants
const DAILY_TRANSFER_LIMIT_EXCEEDED_ERROR = 'BI_0050';
const DATE_OF_EXECUTION_ERROR = 'PL_5183';
const {
    BENEFICIARY_TYPE_EXISTING,
    FIRST_STEP,
    GRAPHIC_TUTOR_TYPE_4,
    BENEFICIARY_TYPE_NGO,
    BENEFICIARY_TYPE_NEW,
    ROUTE_TYPE_FROM_MOVEMENTS,
    MODAL_MIN_LIMIT_EVENT,
    MODAL_MAX_LIMIT_EVENT,
    MODAL_MAX_LIMIT_ERROR
} = require('constants/index');
const {
    TRANSFERS_SECURITY_WARNING,
    WEB_INACTIVE_ACCOUNT_ENABLED,
    TRANSFERS_POPUP_BETWEEN_3K_25K, 
} = require('constants/flagBasedFeatures');
const {
    recordLinkV2,
} = require('utilities/tagging');
const { catalogue, analyticsId } = require('../../components/transfersSteps/transferSteps/analytics/transferStepsAnalytics');

class TransferView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            depositModalStatus : false,
            redirectBtnClicked : false,
            depositModalWarning : false,
            transferDepositBtnClicked: false,
        }
        this.startNewTransfer = this.startNewTransfer.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.isTransferTypeChangeEnabled = this.isTransferTypeChangeEnabled.bind(this);
        this.handleValidateStep = this.handleValidateStep.bind(this);
        this.handleToggleShowModal = this.handleToggleShowModal.bind(this);
        this.handleToggleShowWarningModal = this.handleToggleShowWarningModal.bind(this);
        this.navigateToNextstep = this.navigateToNextstep.bind(this);
        this.doTagging = this.doTagging.bind(this);
        this.redirectToDeposit = this.redirectToDeposit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleProductOfferClick = this.handleProductOfferClick.bind(this);
        this.onConfirmLeave = this.onConfirmLeave.bind(this);
        this.handlePreLeaveModalCloseButtonClick = this.handlePreLeaveModalCloseButtonClick.bind(this);
    }

    componentWillMount() {
        const {
            history,
            match: { params: { accountId, scheduledId, transferId } },
            immScheduledTransfers,
            immEmitedTransfers
        } = this.props;

        if (accountId) {
            if (scheduledId) {
                const immScheduledTransfer = immScheduledTransfers.getIn([accountId, 'byId', scheduledId]);
                if (!immScheduledTransfer || !immScheduledTransfer.get('details')) {
                    history.push(`/myprofile/transfers/scheduled/${accountId}`)
                } else if (transferId) {
                    const immEmitedTransfer = immEmitedTransfers.getIn([accountId, 'byId', transferId]);
                    if (!immEmitedTransfer) {
                        history.push('/myprofile/transfers');
                    }
                }
            }
        }
    }

    componentDidMount() {
        const {
            match: { params: { accountId, scheduledId, transferId, routeType } },
            handleFetchBeneficiaries,
            fillTransferForm,
            reuseEmitedTransfer,
            reuseMovementTransfer
        } = this.props;

        if (accountId) {
            if (scheduledId) {
                fillTransferForm(accountId, scheduledId);
            } else if (routeType === ROUTE_TYPE_FROM_MOVEMENTS) {
                reuseMovementTransfer(accountId, transferId);
            } else if (transferId) {
                reuseEmitedTransfer(accountId, transferId);
            }
        }

        handleFetchBeneficiaries();
    }

    componentWillUnmount() {
        const { reset, resetBankName, immTransferState, resetInterveners, termsAndCondsReset } = this.props;
        termsAndCondsReset();
        reset();

        const fromAccountId = immTransferState.getIn(['steps', FIRST_STEP, 'fromAccount']);
        if (!!fromAccountId) {
            resetInterveners(fromAccountId);
        }
        resetBankName();
    }

    handleConfirmLeave() {
        const { reset, resetPrintedIndicators } = this.props
        reset()
        resetPrintedIndicators()
    }

    startNewTransfer() {
        this.props.reset();
    }

    handleCancel() {
        this.props.history.push('/myprofile/transfers');
    }

    isTransferTypeChangeEnabled() {
        const { immTransferState, immBeneficiaries } = this.props;
        const immFirstStep = immTransferState.getIn(['steps', FIRST_STEP]);
        const beneficiaryType = immFirstStep.getIn(['beneficiary', 'type']);

        if (beneficiaryType === BENEFICIARY_TYPE_NGO) {
            return false;
        }

        let immBeneficiary;

        if (beneficiaryType === BENEFICIARY_TYPE_EXISTING) {
            const beneficiaryId = immFirstStep.getIn(['beneficiary', 'existing', 'id']);
            immBeneficiary = immBeneficiaries.getIn(['byId', beneficiaryId]);
        } else if (beneficiaryType === BENEFICIARY_TYPE_NEW) {
            immBeneficiary = immFirstStep.getIn(['beneficiary', 'new']);
        }

        if (immBeneficiary) {
            const sepa = isSepa(
                immBeneficiary.get('country'),
                immBeneficiary.get('currency')
            );

            if (!sepa) {
                return false;
            }
        }

        return true;
    }
    handleValidateStep() {
        const {
            immTransferState, validateStep, immFlagBasedFeatures, immVariables
        } = this.props
        const visibleStep = immTransferState.get('visibleStep');
        const immFirstStep = immTransferState.getIn(['steps', FIRST_STEP]);
        const amount = immFirstStep.get("amount")
        const depositLimits = immVariables && immVariables.get('deposit');
        const maxLimit = +depositLimits.get('maxLimit');
        const minLimit = +depositLimits.get('minLimit');
        validateStep(visibleStep, false);
        (amount <= maxLimit) && (amount >= minLimit) && immFlagBasedFeatures.get(TRANSFERS_POPUP_BETWEEN_3K_25K) && this.handleToggleShowModal('open');
    }
    doTagging(eventType) {
        let etiquetaEvento = '';
        switch (eventType) {
            case 'open':
                etiquetaEvento = "vista";
                break;
            case 'close':
                etiquetaEvento = "close";
                break;
            case 'continue':
                etiquetaEvento = "no/continuar transferencia";
                break;
            case 'redirect':
            case 'redirectFromMax':
                etiquetaEvento = "contratar";
                break;
            default:
                break;
        }
        const analyticsData = {
            categoriaEvento: MODAL_MAX_LIMIT_EVENT,
            accionEvento: eventType === 'redirectFromMax' ? MODAL_MAX_LIMIT_ERROR : MODAL_MIN_LIMIT_EVENT,
            etiquetaEvento: etiquetaEvento
        }
        recordLinkV2(analyticsData);
    }

handleToggleShowModal(eventType) {
    this.setState(previousState => ({
        depositModalStatus: !previousState.depositModalStatus
    }),this.doTagging(eventType));
}
handleToggleShowWarningModal() {
    const { immTransferState, showScamWarning } = this.props
    if(immTransferState.get('showScamWarning')){
        showScamWarning(false)
    } else {
        showScamWarning(true)
    }
}
validateWarningModal() {
    const {
        requestScamWarningValidation
    } = this.props;
    return requestScamWarningValidation().finally(()=>{
        return false
    })
}

navigateToNextstep() {
    const { immTransferState,validateStep } = this.props
    const visibleStep = immTransferState.get('visibleStep');
    validateStep(visibleStep);
    this.handleToggleShowModal('continue')
}

onConfirmLeave(){
    recordLinkV2({
        categoriaEvento: window.utag_data.nombrePagina,
        accionEvento: "modal salir transferencia",
        etiquetaEvento: "confirmar"
    });
    const { reset } = this.props;
    if(!__CONTACT_CENTER__){
        reset()
    } else {
        this.handleConfirmLeave()
    }
}


handlePreLeaveModalCloseButtonClick(){
    recordLinkV2({
        categoriaEvento: window.utag_data.nombrePagina,
        accionEvento: "modal salir transferencia",
        etiquetaEvento: "cerrar"
    })
    if(this.state.transferDepositBtnClicked){
        this.setState({transferDepositBtnClicked:!this.state.transferDepositBtnClicked})
    } else {
        return null
    }
}

redirectToDeposit = (source) => {
    this.setState({
        redirectBtnClicked:!this.state.redirectBtnClicked
    },
    () => {
    source ? this.doTagging('redirect'): this.doTagging('redirectFromMax')
    this.props.history.push('/myprofile/purchase/deposit-eighteen-months')
    });
    }

    handleProductOfferClick(product,rest,index) {
        const productName = `${rest.get('type')}.${rest.get('subtype')}`
        recordLinkV2({
            categoriaEvento: "depositos de retencion",
            accionEvento: "click",
            etiquetaEvento: productName,
            tealium_event:"promo_click",
            promotion_name:[productName],
            promotion_id:[productName],
            promotion_creative:[productName],
            promotion_position:[`${index + 1}`]
        });
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: "modal salir transferencia",
            etiquetaEvento: "vista"
        })
        this.setState({
            transferDepositBtnClicked:!this.state.transferDepositBtnClicked
        },
        () => {
            this.props.setTransferToken(product.token);
            this.props.history.push('/myprofile/purchase/deposittransfer')
        }
        );
    }

    buildWizard(accountsList, originAccountsMap) {
        const {
            match: { params: { accountId, beneficiaryId, scheduledId, charity } },
            immTransferState,
            immBankEntity,
            immBeneficiaries,
            immFlagBasedFeatures,
            immProfile,
            setVisibleStep,
            setWillCancel,
            validateStep,
            postTransfer,
            validateEditedScheduledTransfer,
            postEditedScheduledTransfer,
            originCountry,
            immVariables,
            immOffers
        } = this.props;
        const firstStep = immTransferState.getIn(['steps', FIRST_STEP]);
        const immSteps = immTransferState.get('steps');
        const visibleStep = immTransferState.get('visibleStep');
        const initialAccountId = accountId || '';
        const initialBeneficiaryId = beneficiaryId || '';
        const amount = firstStep.get("amount")
        const depositLimits = immVariables && immVariables.get('deposit');
        const maxLimit = +depositLimits.get('maxLimit');
        const minLimit = +depositLimits.get('minLimit');
        const actions = {
            setVisibleStep,
            setWillCancel,
            validateStep: scheduledId ? validateEditedScheduledTransfer : 
            (amount <= maxLimit) && (amount >= minLimit) && immFlagBasedFeatures.get(TRANSFERS_POPUP_BETWEEN_3K_25K) && !immFlagBasedFeatures.get(TRANSFERS_SECURITY_WARNING) ? this.handleValidateStep : validateStep,
            finish: scheduledId ? postEditedScheduledTransfer : postTransfer,
            cancel: this.handleCancel
        };
        const beneficiaryType = firstStep.getIn(['beneficiary', 'type']);
        const beneficiaryExistingId = firstStep.getIn(['beneficiary', 'existing', 'id']);
        const immBeneficiary =
            beneficiaryType === BENEFICIARY_TYPE_EXISTING
                ? immBeneficiaries.getIn(['byId', beneficiaryExistingId])
                : firstStep.getIn(['beneficiary', 'new']);
        const immFinalButton = 'common-confirm';
        const clientFirstName = immProfile.get('nombreCliente') ? immProfile.get('nombreCliente') : '';
        const transferPayerName = immProfile.get('nombreCompleto');
        const preLeaveModalMessage = this.state.transferDepositBtnClicked ? 'mytransfers-mytransfers_goToDepositsLeaveModalDescription' : null;
        const preLeaveModalTitle = this.state.transferDepositBtnClicked ? 'mytransfers-mytransfers_goToDepositsLeaveModalTitle' : null;
        const preLeaveModalRightButtonConfig = this.state.transferDepositBtnClicked ? {
            callback: (finalCallback) => {
                recordLinkV2({
                    categoriaEvento: window.utag_data.nombrePagina,
                    accionEvento: "modal salir transferencia",
                    etiquetaEvento: "cancelar"
                })
                this.setState({transferDepositBtnClicked: !this.state.transferDepositBtnClicked});
                finalCallback();
            }
        } : null;
        const isImmediateTransfer =  immTransferState.get("doTransferImmediate");
         const tealiumData = [
            catalogue[analyticsId.TRANSFER_STEP_1_VIEW](),
            catalogue[analyticsId.TRANSFER_STEP_2_VIEW]({isImmediate: isImmediateTransfer}),
        ];

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                fullWidth={true}
                showPreLeaveModal={this.state.redirectBtnClicked ? false : true}
                preleaveModalMessage={preLeaveModalMessage}
                preleaveModalTitle={preLeaveModalTitle}
                closeModalNewWizard={this.closeModalNewWizard}
                onConfirmLeave={this.onConfirmLeave}
                onCloseButtonClick={this.handlePreLeaveModalCloseButtonClick}
                preleaveModalRightButtonConfig={preLeaveModalRightButtonConfig}
                tealium={tealiumData[visibleStep - 1]}
                isTaggingSecondVersion
            >
                <WizardStep cancelButton={true} position="first" isLoading={immTransferState.get('isFetching') || immOffers.get('loading')}>
                    <TransferStep1
                        originCountry={originCountry}
                        charity={charity}
                        clientFirstName={clientFirstName}
                        immAccounts={originAccountsMap}
                        immBeneficiaries={immBeneficiaries}
                        immOffers={immOffers}
                        accountsIndexes={accountsList.toJS()}
                        initialAccountId={initialAccountId}
                        initialBeneficiaryId={initialBeneficiaryId}
                        immTransferState={immTransferState}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                        transferPayerName={transferPayerName}
                        immBankEntity={immBankEntity}
                        immProfile={immProfile}
                        history={this.props.history}
                        isTransferTypeChangeEnabled={__CONTACT_CENTER__ ? this.isTransferTypeChangeEnabled : undefined}
                        immediateTransfersEnabled={immFlagBasedFeatures.get('immediate-transfers-enabled')}
                        depositLimits={depositLimits}
                        redirectToDeposit={this.redirectToDeposit}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        handleProductOfferClick={this.handleProductOfferClick}
                        scheduledId={scheduledId}
                    />
                </WizardStep>
                <WizardStep
                    cancelButton={true}
                    immFinalButton={immFinalButton}
                    position="last"
                    addLoadingBehaviour={true}
                    isLoading={immTransferState.get('isFetching')}>
                    <TransferStep2
                        immAccounts={originAccountsMap}
                        immBankEntity={immBankEntity}
                        immBeneficiary={immBeneficiary}
                        immTransferState={immTransferState}
                        transferPayerName={transferPayerName}
                        isTransferTypeChangeEnabled={__CONTACT_CENTER__ ? this.isTransferTypeChangeEnabled : undefined}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildSuccessful() {
        const {
            immAccountsState,
            immBankEntity,
            immBeneficiaries,
            immProfile,
            immTransferState,
            newTransferGetPdf
        } = this.props;
        const firstStep = immTransferState.getIn(['steps', FIRST_STEP]);
        const originAccountId = firstStep.get('fromAccount');
        const originAccount = immAccountsState.getIn(['byId', originAccountId]);
        const beneficiaryType = firstStep.getIn(['beneficiary', 'type']);
        const beneficiaryExistingId = firstStep.getIn(['beneficiary', 'existing', 'id']);
        const immBeneficiary =
            beneficiaryType === BENEFICIARY_TYPE_EXISTING
                ? immBeneficiaries.getIn(['byId', beneficiaryExistingId])
                : firstStep.getIn(['beneficiary', 'new']);
        const transferPayerName = immProfile.get('nombreCompleto');

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 transfer-view__left-first-box-full">
                <TransferSuccessStep
                    callback={this.startNewTransfer}
                    immAccounts={immAccountsState.get('byId')}
                    immBankEntity={immBankEntity}
                    immBeneficiary={immBeneficiary}
                    immTransferState={immTransferState}
                    originAccount={originAccount}
                    transferPayerName={transferPayerName}
                    willLeave={this.props.willLeave}
                    newTransferGetPdf={newTransferGetPdf}
                    isTransferTypeChangeEnabled={__CONTACT_CENTER__ ? this.isTransferTypeChangeEnabled : undefined}
                />
            </div>
        );
    }

    buildMappingBreadcrumb() {
        const { match: { params: { accountId, scheduledId, transferId } } } = this.props;
        let mappingBreadcrumb;

        if (scheduledId) {
            mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-transfers'),
                    url: '/myprofile/transfers'
                },
                {
                    text: formatText('transfersLanding-scheduledTranfers'),
                    url: `/myprofile/transfers/scheduled/${accountId}`
                },
                {
                    text: toCamelCase(formatText('editScheduledTransfer-modify'))
                }
            ];
        } else if (transferId) {
            mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-transfers'),
                    url: '/myprofile/transfers'
                },
                {
                    text: formatText('transfersLanding-emitedTranfers'),
                    url: `/myprofile/transfers/emited/${accountId}`
                },
                {
                    text: toCamelCase(formatText('transfersEmited-reUseTransfer'))
                }
            ];
        } else {
            mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-transfers'),
                    url: '/myprofile/transfers'
                },
                {
                    text: toCamelCase(formatText('mytransfers-transfer'))
                }
            ];
        }

        return mappingBreadcrumb;
    }

    getTransferErrorMsg() {
        const { immTransferState } = this.props;
        let errorSubMessage = <FormattedText value="mytransfers-errorTransferMessage" />;

        if (immTransferState.get('error') === DAILY_TRANSFER_LIMIT_EXCEEDED_ERROR ) {
            errorSubMessage = <FormattedText value="mytransfers-mytransfers_errorDailyTransferLimitExceeded" />;
        } else if (immTransferState.get('error') === DATE_OF_EXECUTION_ERROR) {
            errorSubMessage = <FormattedText value="mytransfers-errorDateOfExecution" />;
        }

        return errorSubMessage;
    }

    buildEmptyOriginAccounts() {
        const title = formatText('mytransfers-noFromAccountsTitle');
        const primaryText = formatText('mytransfers-noOriginAccountsMessage');
        const linkText = formatText('mytransfers-errorBackToTransfersLink');
        const backToTransfersLink = '/myprofile/transfers';
        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 transfer-view__left-first-box-full">
                <OKSectionBox>
                    <EmptyState
                        title={title}
                        primaryText={primaryText}
                        linkText={linkText}
                        linkURL={backToTransfersLink}
                        iconType="noitems-banking"
                    />
                </OKSectionBox>
            </div>
        );
    }

    buildCannotUpdateScheduledTransferWarningMessage() {
        const title = formatText('myTransfers-cannotUpdateScheduledTransferTitle');
        const subtitle = formatText('myTransfers-cannotUpdateScheduledTransferSubtitle');
        const backToTransfersLink = '/myprofile/transfers';
        const linkText = formatText('myTransfers-errorBackToTransfersLink');

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 transfer-view__left-first-box-full">
                <OKSectionBox className="transfer-view__cannot-update-section">
                    <div>
                        <div className="transfer-view__cannot-update-icon">
                            <span className="transfer-view__cannot-update-span-icon"><i className="transfer-view__cannot-update-icon-warning" /></span>
                        </div>
                        <div className="transfer-view__cannot-update-content">
                            <div>
                                <OKBoxTitle value={title} />
                                <p className="transfer-view__cannot-update-subtitle">{subtitle}</p>
                            </div>
                            <div className="transfer-view__cannot-update-footer">
                                <OKLink to={backToTransfersLink}>
                                    <span className="transfer-view__cannot-update-link">{linkText}</span>
                                </OKLink>
                            </div>
                        </div>
                    </div>
                </OKSectionBox>
            </div>
        );
    }

    cannotUpdateScheduledTransfer() {
        const { immTransferState } = this.props;
        const immFirstStep = immTransferState.getIn(['steps', FIRST_STEP]);

        return immFirstStep.get('periodicityEnabled') && (immFirstStep.get('periodicityCodeFromService') === '200' || immFirstStep.get('periodicityCodeFromService') === '107');
    }

    render() {
        const {
            match: { params: { scheduledId, transferId } },
            immTransferState,
            immAccountsState,
            immBeneficiaries,
            immVariables,
            immFlagBasedFeatures,
            termsAndCondsInfo
        } = this.props;
        const mappingBreadcrumb = this.buildMappingBreadcrumb();
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-transferTitle')}
            />
        );
        let transferContent = <div />;
        let moreOptionsButton;
        let optionsButton;
        let titleKey;

        if (scheduledId) {
            titleKey = 'editScheduledTransfer-editScheduledTransfer';
        } else if (transferId) {
            titleKey = 'transfersEmited-reUseTransfer';
        } else {
            titleKey = 'mytransfers-newTransfer';
        }

        const allAccountsInactive = hasAllAccountsInactive(
            immAccountsState.get('byOrder'),
            immAccountsState.get('byId')
        );

        if (allAccountsInactive) {
            transferContent = (<InactiveAccountsError
                navigateToBackButtonText={'transfers'}
                navigateToBackButtonURL={'transfers'}
            />);
        }
        else if (immAccountsState.get('isFetching')) {
            // Loading state coming soon
            transferContent = <LoadingSection />;
        } else if (immTransferState.get('submitSuccessful')) {
            transferContent = this.buildSuccessful();
        } else if (immBeneficiaries.get('error')) {
            transferContent = <TransferViewErrors errorMessage={formatText('mytransfers-errorBeneficiariesMessage')} />;
        } else if (immTransferState.get('transferFailed')) {
            const errorSubMessage = this.getTransferErrorMsg();
            transferContent = <TransferViewErrors errorMessage={errorSubMessage} />;
        } else if (immTransferState.get('limitError')) {
            const errorLimitText = (<FormattedText
                injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                value="mytransfers-mytransfers_errorTermsAndConditions"
        />)
            transferContent = (<TransferViewErrors
                injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                errorMessage={errorLimitText}
            />);
        } else if (termsAndCondsInfo.get('error')) {
            const errorSubMessage = (<FormattedText
                injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                value="mytransfers-mytransfers_errorTermsAndConditions"
            />);
            transferContent = <TransferViewErrors errorMessage={errorSubMessage} />;
        } else if (__CONTACT_CENTER__ && scheduledId && this.cannotUpdateScheduledTransfer()) {
            transferContent = this.buildCannotUpdateScheduledTransferWarningMessage();
        } else if (immAccountsState.get('byOrder').size > 0) {
            const wizard = this.buildWizard(
                immAccountsState.get('byOrder'),
                immAccountsState.get('byId')
            );
            const immAccount = immAccountsState
                .get('byId')
                .get(immAccountsState.get('byOrder').get(0));

            moreOptionsButton = <TransfersMoreOptionsButton hiddenOnMobile immAccount={immAccount} />;
            optionsButton = <TransfersOptionsButton hiddenOnMobile immAccount={immAccount} />;
            transferContent = (
                <div className="col-xs-12">
                    {wizard}
                </div>
            );
        } else {
            transferContent = this.buildEmptyOriginAccounts();
        }
        let depositModal;
        let depositWarningModal;
        if(immTransferState.get('showScamWarning')){
            depositWarningModal = 
                (<TransferViewWarningModal
                    isOpen={immTransferState.get('showScamWarning')}
                    onFailedTermsAcepted={this.handleToggleShowWarningModal}
                    onSecondaryButtonClick={this.handleToggleShowWarningModal}
        />)
        }
        if(this.state.depositModalStatus){

            const transferModalMinLimitTitle = formatText("transferSummary-transferModalMinLimitTitle");
            const transferModalMinLimitContent = formatText("transferSummary-transferModalMinLimitContent");
            const transferModalMinLimitPrimaryButtonText = formatText('transferSummary-transferModalMinLimitPrimaryButtonText')
            const transferModalMinLimitSecondaryButtonText = formatText('transferSummary-transferModalMinLimitSecondaryButtonText')
            let modalContent2 = (<p>{transferModalMinLimitContent}</p>);
            const immFirstStep = immTransferState.getIn(['steps', FIRST_STEP]);
            const isValidForm = immFirstStep.get("valid", true);
            const amount = immFirstStep.get("amount");
            const depositLimits = immVariables && immVariables.get('deposit');
            const maxLimit = +depositLimits.get('maxLimit');
            const minLimit = +depositLimits.get('minLimit');
            let limitCondition2 = isValidForm && ((amount <= maxLimit) && (amount >= minLimit)) && immFlagBasedFeatures.get(TRANSFERS_POPUP_BETWEEN_3K_25K);
            depositModal = limitCondition2 &&
                <OKModal
                    content={modalContent2}
                    isOpen={this.state.depositModalStatus}
                    onCloseCallback={() => this.handleToggleShowModal('close')}
                    onPrimaryButtonClick={this.navigateToNextstep}
                    primaryButtonText={transferModalMinLimitPrimaryButtonText}
                    title={transferModalMinLimitTitle}
                    footerType="action"
                    onSecondaryButtonClick={this.redirectToDeposit}
                    secondaryButtonText={transferModalMinLimitSecondaryButtonText}
                />
        }
        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle(titleKey)}>
                                {moreOptionsButton}
                                {optionsButton}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {transferContent}
                            {depositWarningModal}
                            {depositModal}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TransferView.propTypes = {
    fillTransferForm: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    handleFetchBeneficiaries: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccountsState: PropTypes.object.isRequired,
    immBankEntity: PropTypes.object.isRequired,
    immBeneficiaries: PropTypes.object.isRequired,
    immEmitedTransfers: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immScheduledTransfers: PropTypes.object,
    termsAndCondsInfo: PropTypes.object,
    immTransferState: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    postEditedScheduledTransfer: PropTypes.func.isRequired,
    postTransfer: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetBankName: PropTypes.func.isRequired,
    resetInterveners: PropTypes.func.isRequired,
    reuseEmitedTransfer: PropTypes.func.isRequired,
    reuseMovementTransfer: PropTypes.func.isRequired,
    setTransferToken: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateEditedScheduledTransfer: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    willLeave: PropTypes.func.isRequired,
    newTransferGetPdf: PropTypes.func.isRequired,
    showScamWarning: PropTypes.func,
    originCountry: PropTypes.string,
    immVariables: PropTypes.object,
    termsAndCondsActions: PropTypes.object,
    termsAndCondsReset:PropTypes.object,
    requestScamWarningValidation: PropTypes.func.isRequired
};

module.exports.constructor = TransferView;
module.exports.TransferView = connect(
    state => ({
        immAccountsState: state.accounts,
        fromRenewalOrTransferToken: state.contracts,
        immBankEntity: state.bankEntity,
        immBeneficiaries: state.beneficiaries,
        immOffers: state.offers,
        immEmitedTransfers: state.emitedTransfers,
        immFlagBasedFeatures: state.flagBasedFeatures,
        termsAndCondsInfo: state.termsAndCondsInfo,
        immProfile: state.profile,
        immScheduledTransfers: state.scheduledTransfers,
        immTransferState: state.transfer,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
        originCountry: state.profile.get('originCountry'),
    }),
    {
        termsAndCondsReset: termsAndCondsInfoActions.reset,
        postTransfer: transferActions.postTransfer,
        resetPrintedIndicators: printerActions.resetPrintedIndicators,
        validateStep: transferActions.validateStep,
        setVisibleStep: transferActions.setVisibleStep,
        setTransferToken: contractsActions.setRenewalOrTransferToken,
        reset: transferActions.reset,
        setWillCancel: transferActions.setWillCancel,
        willLeave: transferActions.setWillLeave,
        reuseEmitedTransfer: transferActions.reuseEmitedTransfer,
        reuseMovementTransfer: transferActions.reuseMovementTransfer,
        handleFetchBeneficiaries: transferActions.handleFetchBeneficiaries,
        showScamWarning: transferActions.showScamWarning,
        fillTransferForm: scheduledTransfersActions.fillTransferForm,
        validateEditedScheduledTransfer: scheduledTransfersActions.validateEditedScheduledTransfer,
        postEditedScheduledTransfer: scheduledTransfersActions.postEditedScheduledTransfer,
        resetInterveners: intervenersActions.resetAccountInterveners,
        requestScamWarningValidation: transferActions.requestScamWarningValidation,
        resetBankName: bankEntityActions.resetBankName,
        newTransferGetPdf: emitedTransfersDetailsActions.newTransferGetPdf
    }
)(withRouter(TransferView));
